/**
 * Subscription selection states for controlling the Choose Plan screen visibility
 */
export const SubscriptionState = {
  /** Hide Choose Plan screen - normal application flow */
  HIDDEN: 0,

  /** Show Choose Plan screen - user needs to select a plan */
  SHOW_PLAN_SELECTION: 1,

  /** Show Choose Plan screen with paid plan pre-selected */
  SHOW_PAID_PLAN_SELECTED: 2,
} as const;

export type SubscriptionStateType = typeof SubscriptionState[keyof typeof SubscriptionState];
